import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className, ...rest }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8, delay, ease: EASE }}
        className={className}
        {...rest}
    >
        {children}
    </motion.div>
);

export const Eyebrow = ({ children }) => (
    <span className="inline-flex items-center gap-3 text-xs font-mono uppercase tracking-[0.3em] text-[#00C2FF]">
        <span className="h-px w-8 bg-white/20" aria-hidden="true" />
        {children}
        <span className="h-px w-8 bg-white/20" aria-hidden="true" />
    </span>
);
